import { useSelector } from "react-redux";
import { t } from "../../translations";
import "../styles/help-center.css";

const HelpCenter = () => {
  const lang = useSelector((state) => state.lang);

  return (
    <div className="help-center-container">
      <h1 className="help-center-title">{t("help_center.title", lang)}</h1>

      <div className="help-center-intro">
        <p className="help-center-text">
          {t("help_center.welcome_message", lang)}
        </p>
        <p className="help-center-text help-center-text-margin-top">
          <strong className="help-center-strong">
            {t("help_center.availability_hours", lang)}
          </strong>
        </p>
        <p className="help-center-text help-center-text-margin-top-large">
          {t("help_center.choose_option", lang)}
        </p>
      </div>

      <hr className="help-center-divider" />

      <div className="help-center-section">
        <h2 className="help-center-section-title">
          {t("help_center.live_chat.title", lang)}
        </h2>
        <ul className="help-center-list">
          <li className="help-center-list-item">
            <span className="help-center-bullet">•</span>
            <span>
              {t("help_center.live_chat.instruction", lang)}
              <span
                className="help-center-chat-icon"
                title={t("help_center.live_chat.icon_title", lang)}
              >
                <span className="help-center-chat-icon-emoji">💬</span>
              </span>
              {t("help_center.live_chat.instruction_suffix", lang)}
            </span>
          </li>
        </ul>
      </div>

      <div className="help-center-section">
        <h2 className="help-center-section-title">
          {t("help_center.email.title", lang)}
        </h2>
        <ul className="help-center-list">
          <li className="help-center-list-item">
            <span className="help-center-bullet">•</span>
            <span>
              {t("help_center.email.instruction", lang)}{" "}
              <a
                href="mailto:support@panichef.com"
                className="help-center-email-link"
              >
                support@panichef.com
              </a>
            </span>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default HelpCenter;
